import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function LoginPlease() {
    return (
        <div>
            <p className="text-xl text-white">Please <a className="text-blue-500" href='/login'>login</a> or <a className="text-blue-500" href='/signup'>sign up</a> to view this profile.</p>
        </div>
    )
}

export function EditsSuccessful() {
    let navigate = useNavigate();
    React.useEffect(function () {
        setTimeout(function () {
            navigate('/login')
        }, 5000)
    }, [])

    return (
        <div>
            <p className="text-xl text-white">Your profile has been updated successfully. You can log in again. You will be redirected in 5 seconds. If that doesn't happen. Please click <a href='/login' className="text-blue-500">here</a></p>
        </div>
    )
}

export function VerificationSuccessful() {
    let navigate = useNavigate();
    React.useEffect(function () {
        setTimeout(function () {
            navigate('/login')
        }, 5000)
    }, [])

    return (
        <div>
            <p className="text-xl text-white">Your account email has been verified successfully. You can log in again. You will be redirected in 5 seconds. If that doesn't happen. Please click <a href='/login' className="text-blue-500">here</a></p>
        </div>
    )
}

export function VerificationFailed() {
    let navigate = useNavigate();
    React.useEffect(function () {
        setTimeout(function () {
            navigate('/')
        }, 5000)
    }, [])

    return (
        <div>
            <p className="text-xl text-white">Your account verification has failed. Please contact support. You will be redirected in 5 seconds. If that doesn't happen. Please click <a href='/login' className="text-blue-500">here</a></p>
        </div>
    )
}